import { memo } from 'react';
import { BaseNodeUI } from './BaseNodeUI';
import { MapPin } from 'lucide-react';

export default memo(({ data, selected }: any) => {
    return (
        <div className="relative h-full">
            <BaseNodeUI
                title={data.label || 'Geolocation'}
                icon={MapPin}
                colorClass="text-rose-600"
                bgClass="bg-rose-100/50"
                selected={selected}
                isSource={true}
                isTarget={true}
                hideHandles={false}
            >
            </BaseNodeUI>
        </div>
    );
});
